<div
  class="slide-item-comp"
  (mouseover)="onMouseOver()"
  (mouseout)="onMouseOut()"
>
  <!-- [ngClass]="{ selected: selected$ | async }" -->
  <ng-container *ngIf="!newSceneMode">
    <div class="preview" [class.selected]="isSelected" (click)="click($event)">
      <img
        [src]="getThumbnailDataUrl()"
        alt=""
        style="
          width: 100%;
          height: 100%;
          object-fit: contain;
          background-color: transparent;
        "
        [style.visibility]="!imgError && imgLoaded ? 'visible' : 'hidden'"
        (load)="imgLoaded = true; imgError = false"
        (error)="imgError = true; imgLoaded = false"
      />
      <div
        class="icon-container flex-row gap-2 position-absolute"
        style="background-color: white; z-index: 100"
        [style.top.px]="6"
        [style.right.px]="6"
      >
        <nw-icon
          type="close"
          [outlined]="true"
          [size]="12"
          (click)="$event.stopPropagation(); onDelete()"
          matTooltip="Delete scene"
        ></nw-icon>
      </div>
    </div>

    <!-- <nw-editable-text
      [text]="slide?.literals?.label || 'Untitled Slide'"
      (textChanged)="updateLabel($event)"
      [inputWidth]="120"
    ></nw-editable-text> -->
  </ng-container>
  <div
    style="
      width: -webkit-fill-available;
      display: flex;
      justify-content: space-around;
      margin: 2px auto 0;
      height: 13px;
      border: 1px solid black;
      width: 172px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    "
    [style.visibility]="isSelected && hovered ? 'visible' : 'hidden'"
    (click)="addScene()"
  >
    <div style="color: black">+</div>
  </div>
  <div
    *ngIf="newSceneMode"
    class="preview flex-row space-around"
    (click)="click($event)"
  >
    <nw-icon type="add"></nw-icon>
  </div>
</div>
